// removed by extract-text-webpack-plugin
module.exports = {"root":"Login__root___3W0ic","loginForm":"Login__loginForm___WEs1V","title":"Login__title___2wHNh","label":"Login__label___-c8UH","button":"Login__button___3JVCl"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Login/Login.scss
// module id = 972
// module chunks = 0